import React from "react";
import { Box, TextField } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import Header from "../../../components/Header";
import { useAlert } from "../../../global/AlertContext";
import { useNavigate } from "react-router-dom";
import SuccessButton from "../../../components/SuccessButton";
import CancelButton from "../../../components/CancelButton";
import { useCreateSupplierMutation } from "../../../services/supplierService";

const CreateSupplier = () => {
  const showAlert = useAlert();
  const navigate = useNavigate();

  const [createSupplier] = useCreateSupplierMutation(); // Changed to use createSupplier

  const handleFormSubmit = async (supplier, { resetForm }) => {
    try {
      await createSupplier(supplier).unwrap();
      showAlert("Proveedor creado!", "success");
      resetForm();
      navigate('/suppliers'); // Redirect to the suppliers list page
  
    } catch (error) {
      console.error("Error creating supplier:", error);
      showAlert(error.message, "error");
    }
  };

  const initialValues = {
    name: "",
    contact_info: ""
  };

  const supplierSchema = yup.object().shape({
    name: yup.string().required("Requerido"),
    contact_info: yup.string().required("Requerido")
  });

  return (
    <Box m="20px">
      <Header title="Proveedores" subtitle="Crear Proveedor" />
      <Formik
        onSubmit={(values, { resetForm }) => handleFormSubmit(values, { resetForm })}
        initialValues={initialValues}
        validationSchema={supplierSchema}
      >
        {({ values, errors, touched, handleBlur, handleChange, handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <Box
              display="grid"
              gap="30px"
              gridTemplateColumns="repeat(4, minmax(0, 1fr))"
            >
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Nombre del Proveedor"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.name}
                name="name"
                error={!!touched.name && !!errors.name}
                helperText={touched.name && errors.name}
                sx={{ gridColumn: "span 2" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Información de Contacto"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.contact_info}
                name="contact_info"
                error={!!touched.contact_info && !!errors.contact_info}
                helperText={touched.contact_info && errors.contact_info}
                sx={{ gridColumn: "span 2" }}
              />
            </Box>
            <Box
              display="flex"
              justifyContent="end"
              textAlign="center"
              gap="4px"
              mt="1vh"
            >
              <CancelButton label="Cancelar" onClick={() => navigate('/suppliers')} />
              <SuccessButton label="Crear Proveedor" />
            </Box>
          </form>
        )}
      </Formik>
    </Box>
  );
};

export default CreateSupplier;
